var map = {
	"./logo-alphabet.svg": 5073,
	"./logo-amazon-2.svg": 5074,
	"./logo-amazon.svg": 5075,
	"./logo-azercell.svg": 5076,
	"./logo-bank-of-america.svg": 5077,
	"./logo-barclays.svg": 5078,
	"./logo-bbc.svg": 5079,
	"./logo-bnp-paribas.svg": 5080,
	"./logo-booking.svg": 5081,
	"./logo-citibank.svg": 5082,
	"./logo-coca-cola.svg": 5083,
	"./logo-deloitte.svg": 5084,
	"./logo-experian.svg": 5085,
	"./logo-facebook.svg": 5086,
	"./logo-g.svg": 5087,
	"./logo-goldman-sachs.svg": 5088,
	"./logo-google.svg": 5089,
	"./logo-h.svg": 5090,
	"./logo-henkel.svg": 5091,
	"./logo-hsbc.svg": 5092,
	"./logo-ikea.svg": 5093,
	"./logo-infineon.svg": 5094,
	"./logo-instagram.svg": 5095,
	"./logo-jp-morgan.svg": 5096,
	"./logo-jti.svg": 5097,
	"./logo-linkedin.svg": 5098,
	"./logo-meta.svg": 5099,
	"./logo-morgan-stanley.svg": 5100,
	"./logo-netflix.svg": 5101,
	"./logo-oracle.svg": 5102,
	"./logo-paypal.svg": 5103,
	"./logo-pwc-new.svg": 5104,
	"./logo-pwc.svg": 5105,
	"./logo-spotify.svg": 5106,
	"./logo-tesla.svg": 5107,
	"./logo-visa.svg": 5108,
	"./logo-walmart.svg": 5109,
	"./logo-youtube.svg": 5110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5072;